import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Radio, Modal, Select, Icon} from "antd";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import DeptSelectModal from "../../../view/sysManagement/organizationalStructure/dept/deptSelectModal/DeptSelectModal";



const findTree = (treeData, attr, value)=>{
    if(treeData && treeData[attr] === value){
        return treeData.data;
    }else{
        for(let i = 0; treeData && treeData.children && i < treeData.children.length; i++){
            let res = findTree(treeData.children[i], attr, value);
            if(res){
                return res;
            }
        }
    }
    return null;
};

const {Option} = Select;

class AddRmModal extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            depts: [],
            disableKeys:[],
            type: "机构号",
            submitting:{
                status: false,
                current: 0,
                total: 0
            },
            rmhList: [],
            rmIds: []
        };
        this.getByGroupId(this.props.rmGroupId);
    }

    componentDidMount() {
        this.getRmhList()
    }

    getRmhList() {
        this.request({
            url: "/cm-sites-mmp/rm/all?groupId=all",
            method: "get",
            callBack:(data)=>{
                let rmhList = [];
                if(data && data.length) {
                    rmhList = data;
                }
                this.setState({
                    rmhList
                })
            },
            errorCallBack: err => {

            },
        });
    }

    rmGroupId;
    componentWillReceiveProps(nextProps, nextContext) {
        if(this.rmGroupId !== nextProps.rmGroupId){
            this.getByGroupId(nextProps.rmGroupId);
        }
    }

    show(){
        this.state.rmIds = [];
        this.setState({visible: true});
    }

    hide(){
        this.setState({visible: false});
    }

    getByGroupId = (rmGroupId)=>{
        this.rmGroupId = rmGroupId;
        rmGroupId && this.request({
            url: "/cm-sites-mmp/rm/groupId?groupId=",//融媒号不论分组，只要添加过了就不能加了。这是暂时的想法
            callBack:(rmList)=>{
                let disableKeys = [];
                rmList && rmList.map(rm =>{
                    rm.deptId && disableKeys.push(rm.deptId);
                    rm.userId && disableKeys.push(rm.userId);
                });
                this.state.disableKeys = disableKeys;
                this.setState({})
            }
        });
    };

    batchAddRm = async ()=>{
        if(this.state.submitting.status){
            return ;
        }
        let {depts, type} = this.state;
        if(type === "机构号" && !depts || depts.length === 0){
            return ;
        }
        this.state.submitting.status = true ;
        this.state.submitting.current = 1;
        this.state.submitting.total = depts.length;
        this.setState({});
        for(let i = 0; depts && i < depts.length ; i++){
            let dept = depts[i];
            let err = false;
            await this.addRm({deptId:dept.key, rmGroupId:this.props.rmGroupId, type}).catch(()=>{
                err = true;
            });
            if(err){
                message.error(`第${this.state.submitting.current}个融媒号${dept.label}添加失败！`);
                break;
            }
            this.state.submitting.current ++ ;
            this.setState({});
        }
        if(this.state.submitting.current === this.state.submitting.total){
            message.error(`添加成功！`);
        }
        this.state.visible = false ;
        this.state.submitting.status = false ;
        this.state.submitting.current = 0;
        this.state.submitting.total = 0;
        this.setState({});
        this.props.onOk && this.props.onOk();
    };

    addRm = async ({userId, deptId, rmGroupId, type})=>{
        return new Promise((resolve, reject) => {
            this.request({
                url: "/cm-sites-mmp/rm/add",
                body: { userId, deptId, rmGroupId, type },
                method: "post",
                contentType: "json",
                loading:false,
                callBack:data=>resolve(data),
                errorCallBack: err=>reject(err),
                serverVerify:{
                    serverErrorCallBack :err=>reject(err),
                    isShowErrorMsg:true
                }
            });
        });
    };

    addRmh() {
        if(!this.state.rmIds || this.state.rmIds.length === 0) {
            message.info("请选择融媒号！");
            return;
        }
        this.request({
            url: "/cm-sites-mmp/rm/addToGroup",
            body: { rmIds: this.state.rmIds, groupId: this.props.rmGroupId },
            method: "get",
            callBack:(data)=>{
                if(data) {
                    message.success("添加成功！");
                    this.state.visible = false ;
                    this.setState({});
                    this.props.onOk && this.props.onOk();
                }
            },
            serverVerify:{
                serverErrorCallBack:(e,allData)=>{
                  if(allData.status === 5001){
                      this.state.visible = false ;
                      this.setState({});
                      this.props.onOk && this.props.onOk();
                  }
                },
            },
        });
    }

    render() {
        return (
            <Modal
                title={"添加融媒号"}
                width={640}
                maskClosable={false}
                keyboard={false}
                visible={this.state.visible}
                onCancel={()=>this.hide()}
                okText={<>确定{this.state.submitting.status && <span>（{this.state.submitting.current}/{this.state.submitting.total}）<Icon type="loading" /></span>}</>}
                onOk={()=>{
                    // this.batchAddRm();
                    this.addRmh();
                }}
            >
                <table cellPadding={0} cellSpacing={0} border={0} width={"100%"}><tbody>
                    {/*<tr height={50}>*/}
                    {/*    <td width={80} align={"right"}>选择类型：</td>*/}
                    {/*    <td>*/}
                    {/*        <Radio.Group*/}
                    {/*            defaultValue={"机构号"}*/}
                    {/*            onChange={e => this.setState({type:e.target.value})}*/}
                    {/*            value={this.state.type}*/}
                    {/*        >*/}
                    {/*            <Radio value={"机构号"}>机构号</Radio>*/}
                    {/*            <Radio value={"达人号"}>达人号</Radio>*/}
                    {/*        </Radio.Group>*/}
                    {/*    </td>*/}
                    {/*</tr>*/}
                    <tr height={50}>
                        <td width={100} valign={"top"} align={"right"} style={{lineHeight:"50px"}}>融媒号选择：</td>
                        <td style={{position: "relative"}} id={"rmSelect"}>
                            <Select
                                placeholder={"请选择"}
                                style={{width:480}}
                                mode={"multiple"}
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                notFoundContent={null}
                                value={(this.state.rmIds.length > 0 && this.state.rmIds) || undefined}
                                onChange={(rmIds,b)=>{
                                    this.setState({rmIds});
                                }}
                            >
                                {this.state.rmhList.length  > 0 && this.state.rmhList.map((item, index) =>{
                                    return <Option key={item.id} value={item.id}>{item.name}</Option>
                                })}
                            </Select>
                            <Icon width={12} height={12} style={{
                                position: "absolute",
                                top: 18,
                                right: 18,
                                color: "rgba(0, 0, 0, 0.25)"
                            }} type="right"/>
                            <style>{`#rmSelect .ant-select-selection--multiple .ant-select-selection__choice{max-width: 97%;}`}</style>
                        </td>
                        {/*<td>*/}
                        {/*    <Select*/}
                        {/*        style={{width:480}}*/}
                        {/*        mode={"tags"}*/}
                        {/*        labelInValue={true}*/}
                        {/*        value={this.state.depts}*/}
                        {/*        onDropdownVisibleChange={()=>this.deptSelectModal.treeSelectModal.showModal()}*/}
                        {/*        open={false}*/}
                        {/*        onChange={(depts,b)=>{*/}
                        {/*            this.setState({depts});*/}
                        {/*        }}*/}
                        {/*    />*/}
                        {/*    <DeptSelectModal*/}
                        {/*        ref={deptSelectModal=>this.deptSelectModal = deptSelectModal}*/}
                        {/*        value={this.state.depts.map(item=>item.key)}*/}
                        {/*        handleOk={(data,treeData) => {*/}
                        {/*            let depts = [];*/}
                        {/*            treeData && treeData.length > 0 && data && data.map(id=>{*/}
                        {/*                let item = findTree(treeData[0], "id", id);*/}
                        {/*                item && depts.push({key:id, label:item.name});*/}
                        {/*            });*/}
                        {/*            this.setState({depts});*/}
                        {/*        }}*/}
                        {/*        disableKeys={this.state.disableKeys}*/}
                        {/*        defaultBtnType={''}*/}
                        {/*        checkStrictly={true}*/}
                        {/*        placeholder={"请选择部门"}*/}
                        {/*        onItemDelete={() => {*/}
                        {/*        }}*/}
                        {/*        multiple={true}*/}
                        {/*        treeCheckable={true}*/}
                        {/*    />*/}
                        {/*</td>*/}
                    </tr>
                </tbody></table>
            </Modal>
        );
    }
}

export default AddRmModal;
//获取已发布列表
